// Shared label + helper + error scaffolding for every form field.
// Field-specific components (TextField, SelectField, NumberField,
// Base64Field) compose this rather than each rolling their own.

import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  helper?: ReactNode;
  error?: string | null;
  children: ReactNode;
}

export function Field({
  label,
  htmlFor,
  required,
  helper,
  error,
  children,
}: FieldProps) {
  return (
    <label htmlFor={htmlFor} style={{ display: "grid", gap: 6 }}>
      <span style={{ fontSize: "0.8rem", color: "var(--text-dim)" }}>
        {label}
        {required && <span style={{ color: "var(--crit)" }}>{" *"}</span>}
      </span>
      {children}
      {helper && !error && (
        <span style={{ fontSize: "0.75rem", color: "var(--text-dim)" }}>
          {helper}
        </span>
      )}
      {error && (
        <span style={{ fontSize: "0.75rem", color: "var(--crit)" }}>
          {error}
        </span>
      )}
    </label>
  );
}

export const inputStyle: React.CSSProperties = {
  padding: "8px 10px",
  background: "var(--surface-2)",
  border: "1px solid var(--border)",
  borderRadius: 4,
  color: "var(--text)",
  fontSize: "0.9rem",
  fontFamily: "inherit",
};

export const errorInputStyle: React.CSSProperties = {
  ...inputStyle,
  // Override the full `border` shorthand (not just borderColor) so toggling
  // error state doesn't mix shorthand + longhand, which React warns about.
  border: "1px solid var(--crit)",
};
